<script>
import ModalCloseButton from '@phoenix/mixins/components/common/ModalCloseButton';
import { PhxsgButton } from '@sg/src/View/Components/Atoms/Button';

export default {
  components: {
    PhxsgButton,
  },

  mixins: [ModalCloseButton],
};
</script>

<template>
  <PhxsgButton size="sm" variant="fade" data-cy="modal-close-button" @click="closeModal(modalId)">
    {{ $t('Accessibility.modal.close') }}
  </PhxsgButton>
</template>
